'use strict';

require('./DeviceService');
require('./HandRaiseService');
require('./KayleeService');
require('./RoomService');
var log = require('../../log/Log').channel('LedService');
var sutl = require('../../sutl/Sutl');

angular.module('inara').factory('LedService', LedService);

LedService.$inject = [
    '$interval', '$timeout', 'DeviceService', 'HandRaiseService', 'KayleeService', 'RoomService'
];

function LedService(
    $interval, $timeout, DeviceService, HandRaiseService, KayleeService, RoomService
) {
    // These colors were tuned for the Mimo LED bars, if we use other LEDs, we
    // will want to have platform-specific colors.

    var colors = {
        off: { red: 0, green: 0, blue: 0 },
        red: { red: 255, green: 0, blue: 0 },
        yellow: { red: 255, green: 192, blue: 0 },
        green: { red: 0, green: 192, blue: 0 },
        cyan: { red: 0, green: 192, blue: 255 },
        blue: { red: 0, green: 0, blue: 255 },
        magenta: { red: 255, green: 0, blue: 255 },
        white: { red: 230, green: 255, blue: 250 },
    };
    var calendar = null;
    var calendarEnabled = null;
    var calendarTimeout = null;
    var color = 'off';
    var easeEndColor = 'off';
    var easeInterval = null;
    var easeNumSteps = 4;
    var easeStartColor = 'off';
    var easeStep = 0;
    var factoryInstallMode = null;
    var intensity = 0.5;
    var isRoomOnline = null;
    var isPaired = null;
    var ledCycleColors = [ 'red', 'yellow', 'green', 'cyan', 'blue', 'magenta' ];
    var ledCycleIndex = 0;
    var ledCycleInterval = null;
    var mute = null;
    var onAir = null;
    var onlineState = null;
    var prevControllerLoaded = false;
    var timeForMeeting = null;

    init();

    return {
    };

    function easeLedColor(newColor) {
        if (newColor === easeEndColor) return;
        easeStartColor = color;
        easeEndColor = newColor;
        if (easeInterval !== null) $interval.cancel(easeInterval);
        easeStep = 0;
        setEaseStep(easeStep);
        easeInterval = $interval(onEaseInterval, 80);
    }

    function init() {
        DeviceService.loaded()
        .then(function() {
            if (DeviceService.getDeviceManagerName() !== 'mimo') return;
            setLedColor('white');
            $timeout(function() {
                setLedColor('off');
                RoomService.onStateChanged(onRoomServiceStateChanged);
                RoomService.onOnlineChanged(onRoomOnlineChanged);
                HandRaiseService.subscribeFlashState(updateLed);
            }, 2000);
        });
    }

    function onCalendarChanged() {
        var nextEvent = null;
        var now = Date.now();

        for (var id in calendar.events) {
            if (!calendar.events.hasOwnProperty(id)) continue;

            var event = calendar.events[id];

            if (event.end > now && (nextEvent === null || event.start < nextEvent.start)) {
                nextEvent = event;
            }
        }

        var newTimeForMeeting = nextEvent !== null &&
            nextEvent.start < now + 5 * 60 * 1000;

        if (newTimeForMeeting !== timeForMeeting) {
            timeForMeeting = newTimeForMeeting;
            updateLed();
        }

        if (calendarTimeout !== null) {
            $timeout.cancel(calendarTimeout);
        }

        if (timeForMeeting) {
            calendarTimeout = $timeout(onCalendarChanged,
                nextEvent.end - now + 1000);
        } else if (nextEvent !== null) {
            calendarTimeout = $timeout(onCalendarChanged,
                nextEvent.start - now - 5 * 60 * 1000 + 1000);
        }
    }

    function onControllerChanged(controller) {
        var changed = false;
        var newIsPaired = sutl.getNode(controller, [ 'roomId' ]) !== null;
        var newFactoryInstallMode = sutl.getNode(controller,
            [ 'settings', 'factoryInstallMode' ]);

        if (newIsPaired !== isPaired) {
            isPaired = newIsPaired;
            changed = true;
        }

        if (newFactoryInstallMode !== factoryInstallMode) {
            factoryInstallMode = newFactoryInstallMode;
            changed = true;
        }

        if (changed) updateLed();
    }

    function onEaseInterval() {
        easeStep++;

        if (easeStep >= easeNumSteps) {
            $interval.cancel(easeInterval);
            easeInterval = null;
            setLedColor(easeEndColor);
        } else {
            setEaseStep(easeStep);
        }
    }

    function onLedCycle() {
        var color = ledCycleColors[ledCycleIndex];
        setLedColor(color);
        ledCycleIndex++;
        if (ledCycleIndex >= ledCycleColors.length) ledCycleIndex = 0;
    }

    function onRoomChanged(room) {
        var changed = false;
        var newCalendarEnabled = sutl.getNode(room, 'caps.hasCalendar', false);
        var newMute = sutl.getNode(room, [ 'states', 'mute' ]);
        var newOnlineState = sutl.getNode(room, [ 'states', 'onlineState' ]);
        var newOnAir = sutl.getNode(room, [ 'states', 'onAir' ]);

        if (newCalendarEnabled !== calendarEnabled) {
            calendarEnabled = newCalendarEnabled;

            if (calendarEnabled) {
                room.$getCalendar().$loaded()
                .then(function(resolvedCalendar) {
                    calendar = resolvedCalendar;
                    calendar.$onChange(onCalendarChanged);
                });
            } else {
                if (calendar !== null) calendar.$offChange(onCalendarChanged);
            }
        }

        if (newMute !== mute) {
            mute = newMute;
            changed = true;
        }

        if (newOnlineState !== onlineState) {
            onlineState = newOnlineState;
            changed = true;
        }

        if (newOnAir !== onAir) {
            onAir = newOnAir;
            changed = true;
        }

        if (changed) updateLed();
    }

    function onRoomOnlineChanged(isOnline) {
        var changed = false;

        if (isOnline) {
            RoomService.getRoom().$onChange(onRoomChanged);
        } else {
            mute = false;
            onAir = false;
        }


        if (isOnline !== isRoomOnline) {
            isRoomOnline = isOnline;
            changed = true;
        }

        if (changed) updateLed();
    }

    function onRoomServiceStateChanged(state) {
        if (!prevControllerLoaded && RoomService.isControllerLoaded()) {
            prevControllerLoaded = true;
            RoomService.getController().$onChange(onControllerChanged);
        } else if (prevControllerLoaded && !RoomService.isControllerLoaded()) {
            prevControllerLoaded = false;
        }
    }

    function setEaseStep(step) {
        var fact = (step + 1) / (easeNumSteps + 1);
        var startValue = colors[easeStartColor];
        var endValue = colors[easeEndColor];

        var values = {
            red: startValue.red + (endValue.red - startValue.red) * fact,
            green: startValue.green + (endValue.green - startValue.green) * fact,
            blue: startValue.blue + (endValue.blue - startValue.blue) * fact,
        };

        DeviceService.setRgbLeds(intensity * values.red, intensity * values.green,
            intensity * values.blue);
    }

    function setLedColor(newColor) {
        if (easeInterval !== null) {
            $interval.cancel(easeInterval);
            easeInterval = null;
        }

        color = newColor;

        if (!colors.hasOwnProperty(color)) color = 'off';
        var values = colors[color];
        DeviceService.setRgbLeds(intensity * values.red, intensity * values.green,
            intensity * values.blue);
    }

    function startLedCycle() {
        onLedCycle();
        ledCycleInterval = $interval(onLedCycle, 1000);
    }

    function stopLedCycle() {
        if (ledCycleInterval !== null) {
            $interval.cancel(ledCycleInterval);
            ledCycleInterval = null;
        }
    }

    function updateLed() {
        log.debug('updateLed');

        stopLedCycle();

        if (factoryInstallMode) {
            startLedCycle();
        } else if (RoomService.online()) {
            var ledColor = 'off';

            if (mute) {
                ledColor = 'red';
            } else if (onAir) {
                ledColor = 'green';
            }

            if (HandRaiseService.isFlashing()) {
                easeLedColor(HandRaiseService.flashState() ? 'blue' : ledColor);
            } else {
                setLedColor(ledColor);
            }

        } else {
            setLedColor('off');
        }
    }
}

module.exports = LedService;
